module.exports = __webpack_public_path__ + "static/media/01.9259ff64.png";